/**
 * gameKit — gedeelde bouwstenen voor de geheime game-widgets. Verdeelt de widget in
 * een score-zone (boven) en een game-zone (vult de rest), beide met een outline
 * zoals de Klok-widget. useFitSquare meet de game-zone zodat het bord altijd een
 * passend vierkant is (in elke widgethoogte).
 */
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { T } from './widgetTokens';

export const RING = { border: `1.5px solid ${T.surfaceHigh}`, borderRadius: '0.7rem' };

// Meet de container en geef de grootste passende vierkante zijde (px) terug.
export function useFitSquare() {
  const ref = useRef(null);
  const [size, setSize] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(() => {
      const r = el.getBoundingClientRect();
      setSize(Math.max(0, Math.floor(Math.min(r.width, r.height))));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, size];
}

export function GameFrame({ score, children }) {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ ...RING, flexShrink: 0, px: 1.5, py: 1 }}>{score}</Box>
      <Box sx={{ ...RING, flex: 1, minHeight: 0, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {children}
      </Box>
    </Box>
  );
}
